import _ from 'lodash'
import { fileUrl } from 'src/utils/lib'
import { store } from 'src/App'
import { path } from 'src/constants/path'
import { setReduxValue, setChangeBody } from 'src/redux/slices/eLearning/enroll'
import { openErrorDialog } from 'src/redux/slices/alertDialog'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { USER_TYPE } from 'src/modules/EExamination/constant'
import { getEConfiguration } from 'src/services/eConfiguration'
import { getCourseBatch } from 'src/services/eLearning/enroll'
import { fetchMyEnrollProfile } from 'src/services/class/registration'

export const fetchCourseDetail = (uuid) => async (dispatch) => {
  dispatch(getEConfiguration())
  dispatch(startLoading())
  const response = await dispatch(getCourseBatch(uuid))
  const result = await dispatch(checkProspectDetail()) // ✅ รอให้เสร็จ
  const success = result?.meta?.requestStatus === 'fulfilled'
  if (success) {
    dispatch(setReduxValue({ index: 'isInitialLoaded', value: true }))
  }
  dispatch(stopLoading())

  if (!_.isEmpty(response.error)) {
    const error = _.get(
      response,
      'meta.response.data.constraints',
      _.get(response, 'meta.response.data.response.constraints', {})
    )
    dispatch(
      openErrorDialog({
        ...error,
        title: error.title || 'ผิดพลาด',
        message: error.value || 'ดำเนินการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        buttonRight: {
          handleClick: () =>
            (window.location.href = `${path.eLearningCourse}/${uuid}`),
        },
      })
    )
  }
}

export const getEnrollState = () => {
  return store.getState().eLearningEnroll
}

export const checkProspectDetail = () => async (dispatch) => {
  const result = await dispatch(fetchMyEnrollProfile())
  const prospectDetail = result?.payload
  if (prospectDetail) {
    // 🟢 ดำเนินการต่อจากข้อมูลใน localStorage หรือที่ได้จาก API
    const userImageUrl = prospectDetail.image
      ? fileUrl(prospectDetail.image)
      : '/logo/staff_profile_small.png'

    const type = prospectDetail?.type || 'TEMP'
    const isCanEditProfile = prospectDetail?.isCanEditProfile || false
    const data = [
      {
        uuid: prospectDetail?.uuid || '',
        type: type,
        image: userImageUrl,
        prefixTH: prospectDetail?.prefixTH || '',
        firstNameTH: prospectDetail?.firstNameTH || '',
        lastNameTH: prospectDetail?.lastNameTH || '',
        prefix: prospectDetail?.prefix || '',
        firstName: prospectDetail?.firstName || '',
        lastName: prospectDetail?.lastName || '',
        mobileNo: prospectDetail?.mobileNo?.replace(/-/g, '') || '',
        idCardNo: prospectDetail?.idCardNo || '',
        email: prospectDetail?.email || '',
        isEdit: false,
        birthDate: prospectDetail?.dateOfBirth || '',
        isProfileUpdated: prospectDetail?.isProfileUpdated,
        editable: (() => {
          // Get user type from localStorage to determine role
          // Use userType from localStorage only, don't fallback to type from payload
          const user = JSON.parse(window.localStorage.getItem('user') || '{}')
          const userTypeLocal = user?.userType
          const staffType = _.get(user, 'staffProfile.type', null)
          const isAgent = userTypeLocal === 'AGENT'
          const isStaffAcademy =
            userTypeLocal === 'STAFF' && staffType !== 'NON_ACADEMY'
          const isStaffNonAcademy =
            userTypeLocal === 'STAFF' && staffType === 'NON_ACADEMY'

          // Helper function to check if field has value
          const hasValue = (value) => value && value.trim() !== ''

          // Determine editable state based on role requirements
          if (isAgent) {
            // Agent: Only prefixTH editable if no value (first time), other fields not editable
            return {
              isEditPrefixTH: !hasValue(prospectDetail?.prefixTH),
              isEditName: false,
              isEditSurname: false,
              isEditPrefix: !hasValue(prospectDetail?.prefix),
              isEditNameEN: false,
              isEditSurnameEN: false,
              isEditIdCardNo: false,
              isEditMobile: false,
              isEditBirthDate: false,
            }
          } else if (isStaffAcademy) {
            // Staff Academy: ID Card and DOB editable only if no value, other fields editable only if no value
            return {
              isEditPrefixTH: !hasValue(prospectDetail?.prefixTH),
              isEditName: !hasValue(prospectDetail?.firstNameTH),
              isEditSurname: !hasValue(prospectDetail?.lastNameTH),
              isEditPrefix: !hasValue(prospectDetail?.prefix),
              isEditNameEN: !hasValue(prospectDetail?.firstName),
              isEditSurnameEN: !hasValue(prospectDetail?.lastName),
              isEditIdCardNo: !hasValue(prospectDetail?.idCardNo),
              isEditMobile: !hasValue(prospectDetail?.mobileNo),
              isEditBirthDate: !hasValue(prospectDetail?.dateOfBirth),
            }
          } else if (isStaffNonAcademy) {
            //Staff Non Academy: All fields editable only if no value
            return {
              isEditPrefixTH: !hasValue(prospectDetail?.prefixTH),
              isEditName: !hasValue(prospectDetail?.firstNameTH),
              isEditSurname: !hasValue(prospectDetail?.lastNameTH),
              isEditPrefix: !hasValue(prospectDetail?.prefix),
              isEditNameEN: !hasValue(prospectDetail?.firstName),
              isEditSurnameEN: !hasValue(prospectDetail?.lastName),
              isEditIdCardNo: !hasValue(prospectDetail?.idCardNo),
              isEditMobile: !hasValue(prospectDetail?.mobileNo),
              isEditBirthDate: !hasValue(prospectDetail?.dateOfBirth),
            }
          } else {
            // Default: For Prospect and other types - editable if no data or if can edit profile
            // If no data, allow editing; if has data, check isCanEditProfile
            return {
              isEditPrefixTH:
                (type === USER_TYPE.AGENT &&
                  !hasValue(prospectDetail?.prefixTH)) ||
                (type !== USER_TYPE.AGENT &&
                  (!hasValue(prospectDetail?.prefixTH) || isCanEditProfile)),
              isEditName:
                type !== USER_TYPE.AGENT &&
                (!hasValue(prospectDetail?.firstNameTH) || isCanEditProfile),
              isEditSurname:
                type !== USER_TYPE.AGENT &&
                (!hasValue(prospectDetail?.lastNameTH) || isCanEditProfile),
              isEditPrefix:
                type !== USER_TYPE.AGENT &&
                (!hasValue(prospectDetail?.prefix) || isCanEditProfile),
              isEditNameEN:
                type !== USER_TYPE.AGENT &&
                (!hasValue(prospectDetail?.firstName) || isCanEditProfile),
              isEditSurnameEN:
                type !== USER_TYPE.AGENT &&
                (!hasValue(prospectDetail?.lastName) || isCanEditProfile),
              isEditIdCardNo:
                !(type === USER_TYPE.AGENT || type === USER_TYPE.TEMP) &&
                (!hasValue(prospectDetail?.idCardNo) || isCanEditProfile),
              isEditMobile:
                type !== USER_TYPE.AGENT &&
                (!hasValue(prospectDetail?.mobileNo) || isCanEditProfile),
              isEditBirthDate:
                !(type === USER_TYPE.AGENT || type === USER_TYPE.TEMP) &&
                (!hasValue(prospectDetail?.dateOfBirth) || isCanEditProfile),
            }
          }
        })(),
        isCanEditProfile: isCanEditProfile,
      },
    ]

    dispatch(setChangeBody({ key: 'enroll', value: data }))
    dispatch(setReduxValue({ index: 'formError', value: [[]] }))
    dispatch(setReduxValue({ index: 'enrollFormError', value: [true] }))
    dispatch(setReduxValue({ index: 'formNextButtonDisabled', value: [true] }))

    return result
  } else {
    console.warn('❌ ไม่สามารถโหลดข้อมูลผู้สมัครได้')
    return
  }
}
